import { AxiosInstance } from 'axios';
import {
  GetVacancy,
  GetVacancies,
  parseVacancy,
  parseVacancies,
  parseFeedbacks,
} from './utils';
import {
  Payload,
  GetFeedbacks,
  PromiseVacancy,
  ordersCancelUrl,
  PromiseVacancies,
  VacanciesStatusEnum,
} from './types';
import { formDataInputs } from '@/tools/formdatainputs';

export const getVacanciesData = (api: AxiosInstance) => ({
  getVacancies: async (
    params: any,
    dataParser: Function = parseVacancies,
  ): Promise<PromiseVacancies> => {
    // console.log(params)
    const { data } = await api.get<GetVacancies>(
      VacanciesStatusEnum.GET_EVENT_VACANCIES,
      {
        params,
      },
    );
    // console.log(data)
    return { ...data, data: dataParser(data.data) };
  },
});

export const getVacancyData = (api: AxiosInstance) => ({
  getVacancy: async (
    id: any,
    dataParser: Function = parseVacancy,
  ): Promise<PromiseVacancy> => {
    const { data } = await api.get<GetVacancy>(
      `${VacanciesStatusEnum.GET_EVENT_VACANCY}/${id}`,
    );
    return { ...data, data: dataParser(data.data) };
  },
});

export const getVacanciesFeedbackData = (api: AxiosInstance) => ({
  getVacanciesFeedback: async (
    dataParser: Function = parseFeedbacks,
  ): Promise<any> => {
    const { data } = await api.get<GetFeedbacks>(
      VacanciesStatusEnum.GET_VACANCY_ORDERS,
      {
        params: {
          limit: 100,
        },
      },
    );
    return { ...data, data: dataParser(data.data) };
  },
});

export const postVacancyFeedbackData = (api: AxiosInstance) => ({
  postVacancyFeedback: async (payload: Payload): Promise<any> => {
    const formData = formDataInputs({ ...payload });
    const { data } = await api.post(
      VacanciesStatusEnum.POST_VACANCY_ORDERS_CREATE,
      formData,
    );
    return data;
  },
});

export const postCancelVacancyData = (api: AxiosInstance) => ({
  postCancelVacancy: async (id: string): Promise<any> => {
    const { data } = await api.post(ordersCancelUrl(id));
    return data;
  },
});

export const vacanciesService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getVacancyData(api),
    ...getVacanciesData(api),
    ...postCancelVacancyData(api),
    ...postVacancyFeedbackData(api),
    ...getVacanciesFeedbackData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/vacancies/vacanciesService.ts